

export const fetchSelectedIoTFlowsMemberRoleId = iotflows_member_role_id => {
  return dispatch => {
    dispatch({ type: "SELECTED_IOTFLOWS_MEMBER_ROLE_ID", iotflows_member_role_id });
  };
};
